export const isSituacaoDeArbitramento = (situacaoITBI: any) => {
  const situacoesArbitramento = ['AGUARDANDO_ACEITE', 'EM_CONTESTACAO'];
  return situacoesArbitramento.some(situacao => situacao === situacaoITBI.name);
};

export const getChipColorBySituacao = (situacaoITBI: any) => {
  let color = 'neutral';

  if (isSituacaoDeArbitramento(situacaoITBI)) {
    color = 'warning';
  }

  return color;
};

export const validaPercentualDosProprietarios = (
  proprietarios: any[]
): Promise<void> => {
  return new Promise((resolve, reject) => {
    let totalPercentualDosProprietarios = proprietarios.reduce(
      (total, proprietario) => (total += proprietario.percentual),
      0
    );

    if (parseFloat(totalPercentualDosProprietarios.toFixed(2)) !== 100) {
      return reject('Total dos proprietários difere de 100%');
    }
    resolve();
  });
};

const informaValoresFinanciamento = (declaracaoItbi: any) =>
  declaracaoItbi.tipoItbi.financiado || declaracaoItbi.tipoItbi.anuencia;

const informaValoresFinanciamentoTotal = (declaracaoItbi: any) =>
  informaValoresFinanciamento(declaracaoItbi) &&
  declaracaoItbi.tipoItbi.permiteTotalmenteFinanciado;

const isValidValorTransacaoAvaliacao = (valorTransacaoAvaliacao: any) =>
  !valorTransacaoAvaliacao || valorTransacaoAvaliacao <= 0;

export const validaValorTransacaoAvaliacao = (declaracaoItbi: any): boolean => {
  return informaValoresFinanciamentoTotal(declaracaoItbi)
    ? false
    : isValidValorTransacaoAvaliacao(declaracaoItbi.valorTransacaoAvaliacao);
};

export const validaValorFinanciadoAvaliacao = (
  declaracaoItbi: any
): boolean => {
  return (
    informaValoresFinanciamento(declaracaoItbi) &&
    (!declaracaoItbi.valorFinanciadoAvaliacao ||
      declaracaoItbi.valorFinanciadoAvaliacao <= 0)
  );
};

const informaValorIsencao = (declaracaoItbi: any) =>
  declaracaoItbi.tipoItbi.isencao;

const isValidValorIsencao = (valorIsencao: any, percentualIsencao: any) =>
  (!valorIsencao || valorIsencao <= 0) && percentualIsencao === undefined;

export const validaValorIsencao = (declaracaoItbi: any): boolean => {
  return informaValorIsencao(declaracaoItbi)
    ? isValidValorIsencao(
        declaracaoItbi.valorIsencao,
        declaracaoItbi.percentualIsencao
      )
    : false;
};

const valorIsencaoMaiorItbi = (
  valorIsencao: any,
  valorTransacaoItbi: any,
  percentualIsencao: any
) => valorTransacaoItbi < valorIsencao && percentualIsencao === undefined;

export const validaValorIsencaoMaiorItbi = (declaracaoItbi: any): boolean => {
  return informaValorIsencao(declaracaoItbi)
    ? valorIsencaoMaiorItbi(
        declaracaoItbi.valorIsencao,
        declaracaoItbi.valorTransacaoItbi,
        declaracaoItbi.percentualIsencao
      )
    : false;
};

const percentualIsencaoMenorIgualZero = (percentualIsencao: any) =>
  (!percentualIsencao || percentualIsencao < 1) &&
  percentualIsencao !== undefined;

export const validaPercentualIsencaoMenorIgualZero = (
  declaracaoItbi: any
): boolean => {
  return informaValorIsencao(declaracaoItbi)
    ? percentualIsencaoMenorIgualZero(declaracaoItbi.percentualIsencao)
    : false;
};

const percentualIsencaoMaiorCem = (percentualIsencao: any) =>
  percentualIsencao > 100 && percentualIsencao !== undefined;

export const validaPercentualIsencaoMaiorCem = (
  declaracaoItbi: any
): boolean => {
  return informaValorIsencao(declaracaoItbi)
    ? percentualIsencaoMaiorCem(declaracaoItbi.percentualIsencao)
    : false;
};

export const getDeferirSuccessMessage = (
  declaracaoItbi: any,
  options: {
    includeSetState?: boolean;
    setStateSubmitting?: (step: string, value: boolean) => void;
    setState?: (state: any) => void;
  } = {}
): string => {
  const {
    includeSetState = false,
    setStateSubmitting = null,
    setState = null
  } = options;

  if (includeSetState && setStateSubmitting && setState) {
    setStateSubmitting('step3', false);
    setState({ submitting: false });
  }

  switch (declaracaoItbi.situacaoItbi.name) {
    case 'AGUARDANDO_GERACAO_BOLETO':
      return 'Débito já foi gerado. Clique no ícone para gerar o boleto.';
    case 'AGUARDANDO_PAGAMENTO':
      return 'Débito já foi gerado. Clique no ícone do código de barras para imprimir o boleto.';
    case 'AGUARDANDO_ACEITE':
      return 'Pedido arbitrado. Aguardando informações do requerente.';
    case 'AGUARDANDO_NOTIFICACAO':
      return 'Aguardando a emissão da notificação. Clique no ícone Gerar Notificação';
    default:
      return 'Aguardando geração do débito. Clique no ícone com o cifrão para gerar o débito.';
  }
};
